import { render, staticRenderFns } from "./ViewStyleItem.vue?vue&type=template&id=5a8899ab&scoped=true"
import script from "./ViewStyleItem.vue?vue&type=script&lang=js"
export * from "./ViewStyleItem.vue?vue&type=script&lang=js"
import style0 from "./ViewStyleItem.vue?vue&type=style&index=0&id=5a8899ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8899ab",
  null
  
)

export default component.exports